export default __webpack_public_path__ + "static/banner-bpress-24c608d81514dec3cbdd79f938c7009c.jpg";